export const API_URL_V1_PREFIX = `${process.env.REACT_APP_BASE_URL}v1`;
export const API_URL_V2_PREFIX = `${process.env.REACT_APP_BASE_URL}v2`;
export const API_URL_V3_PREFIX = `${process.env.REACT_APP_BASE_URL}v3`;
